import { SUPPORTED_PORTAL_LANGUAGE } from "i18n/supportedLanguages";
import { LucideLanguages } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import {
	ListContent,
	ListDescription,
	ListItem,
	ListRoot,
	ListTitle,
} from "../ui/list";
import "./translations";

interface Props {
	onClose: VoidFunction;
	open: boolean;
}

const ChangeLanguageDialog: React.FC<Props> = ({ onClose, open }) => {
	const { t, i18n } = useTranslation("changeLanguageDialog");
	const sortedLanguages = React.useMemo(
		() => [...SUPPORTED_PORTAL_LANGUAGE].sort(),
		[],
	);
	const handleSelectLanguage = (language: string) => () => {
		i18n.changeLanguage(language);
		onClose();
	};

	return (
		<Dialog
			open={open}
			onOpenChange={(o) => {
				if (!o) {
					onClose();
				}
			}}
		>
			<DialogContent className="grid-rows-[auto_1fr]">
				<DialogTitle className="flex gap-2 items-center">
					<LucideLanguages className="size-4" />
					{t("title")}
				</DialogTitle>
				<ListRoot className="min-h-0 overflow-y-auto">
					{sortedLanguages.map((language) => (
						<ListItem
							size="dense"
							key={`language-item-${language}`}
							onClick={handleSelectLanguage(language)}
						>
							<ListContent>
								<ListTitle>{t(`default:languages.${language}`)}</ListTitle>
								<ListDescription>
									{["en", "de"].includes(language)
										? undefined
										: t("onlyReportLanguage")}
								</ListDescription>
							</ListContent>
						</ListItem>
					))}
				</ListRoot>
			</DialogContent>
		</Dialog>
	);
};

export default ChangeLanguageDialog;
